// @flow

import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  z-index: 1001;
  padding: 8px;
  ${(props) =>
    props.isVisible && `background-color: ${buildColor("black", "20")};`}
`;

export const CenterSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PlayButton = styled.button`
  display: flex;
  height: 56px;
  width: 56px;
  background-color: ${(props) =>
    !props.isPlaying
      ? `${buildColor("blue", `${props.isURP ? "900" : "700"}`)} !important`
      : " transparent"};
  border-radius: 28px;
  outline: none;
  cursor: pointer;
  margin: 4px;
  ${(props) =>
    !props.isPlaying ? `border: 2px solid ${buildColor("white", "100")};` : ""}

  /* only add hover state for fine pointers, meaning that only on desktops using a mouse the hover state will work */
  @media (pointer: fine) {
    &:hover {
      background-color: ${buildColor("white", "20")};
    }
  }

  &:active {
    background-color: ${buildColor("white", "20")};

    /* on touch devices (coarse), the active color should be the hover spec according to the style guide on zeplin */
    @media (pointer: coarse) {
      background-color: ${buildColor("white", "20")};
    }
  }
`;

export const BaseButton = styled.button`
  display: flex;
  height: 32px;
  width: 32px;
  background-color: transparent;
  border-radius: 16px;
  margin: 0 4px;
  outline: none;
  cursor: pointer;

  /* only add hover state for fine pointers, meaning that only on desktops using a mouse the hover state will work */
  @media (pointer: fine) {
    &:hover {
      background-color: ${buildColor("white", "20")};
    }
  }

  &:active {
    background-color: ${buildColor("white", "20")};

    /* on touch devices (coarse), the active color should be the hover spec according to the style guide on zeplin */
    @media (pointer: coarse) {
      background-color: ${buildColor("white", "20")};
    }
  }

  & > div {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
  }
`;

export const RightBottomCornerOverlay = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  padding: 8px 4px;
`;

export const TopRigthCornerOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  padding: 8px 4px;
`;

export const CenterBottomOverlay = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  padding: 8px 16px;
`;

export const FeedBackContainer = styled.div`
  position: relative;
  justify-self: stretch;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & span {
    padding-top: 8px;
  }
`;

export const InnerPlayButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  ${(props) => (props.isPlayIcon ? "margin-left: 2px;" : "")}
`;
